import * as React from "react";

/*
 * A paragraph of text content.
 */
export class Paragraph extends React.Component<
  { children?: React.ReactNode },
  {}
> {
  render(): JSX.Element {
    return (
      <div
        style={{
          paddingBottom: "10px",
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
